/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


function addAllItems(array){
  Shopify.queue = [];
  var newArray = array; //array.split(',');
  for (var i = 0; i < newArray.length; i++) {
    product = newArray[i]
    Shopify.queue.push({
      variantId: product,
    });
  }
  Shopify.moveAlong = function() {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var number = Shopify.queue.length;
      //console.log(number);
      var request = Shopify.queue.shift();

      if (number == variantIdentifiers.length){var quantity = document.querySelector('[name="quantity"]').value;//console.log(quantity);
        var data = 'id='+ request.variantId + '&quantity='+ quantity;
      }
      
      else { var data = 'id='+ request.variantId + '&quantity=1'}
	  var productForm = $('.product-single__form');
      var variantInput = productForm.find('*[name="id"]')
      var quantityInput = productForm.find('input[name="quantity"]')
      var itemQuantity = quantityInput.length > 0 ? quantityInput.val() : 1
      window.dataLayer.push({
        event: 'ee_addToCart',
        name: productForm.find('.ptitle').val(),
        id: productForm.find('.pid').val(),
        price: productForm.find('.pprice').val(),
        brand: productForm.find('.pbrand').val(),
        product_type: productForm.find('.ptype').val(),
        category: productForm.find('.pcollection').val(),
        quantity: itemQuantity,
        variant: variantInput.val(),
        g_product_id: "shopify_AU_"+productForm.find('.pid').val()+"_"+variantInput.val()
      });
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(res){
          Shopify.moveAlong();
          //quantity += 1;
        },
        error: function(XMLHttpRequest){
          // if it's not last one Move Along else update the cart number with the current quantity
          
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $(".add-to-cart").attr("disabled", false);
          $('<p class="ajaxified-cart-feedback">' + response + '</p>').insertAfter(".add-to-cart");
          setTimeout(function() {
            $(".ajaxified-cart-feedback").remove();
          }, 2000);
          $(".add-to-cart").removeClass('btn--loading');
          //console.log(response);
          
          
          if (Shopify.queue.length){
            Shopify.moveAlong()
          } else {
            $(".add-to-cart").removeClass('btn--loading');
            $(".add-to-cart").attr("disabled", false);
            //document.dispatchEvent(new CustomEvent('cart:build'));
            //setTimeout(function() {
            //$(".js-drawer-open-cart").trigger("click");
            //}, 600);
          }
        }
      });
    }
    // If the queue is empty, we add 1 to cart
    else {
      //document.dispatchEvent(new CustomEvent('cart:build'));
      addToCartOk();
    }
  };
  Shopify.moveAlong();
};

function addToCartOk(){  
  $(".add-to-cart").attr("disabled", false);
  $(".add-to-cart").removeClass('btn--loading');
  $('body').trigger('added.ajaxProduct');
}


var variantIdentifiers = [];

$('#Product-select-associated-1').click(function() {
  var value = $( "#Product-select-associated-1 option:selected" ).val();
  $('#Product-check-associated-1').prop('checked', false);
  //console.log(value);
  position = $.inArray(value, variantIdentifiers);
  if ( ~position ) variantIdentifiers.splice(position, 1);
  //console.log(variantIdentifiers);
});


$("#Product-check-associated-1").click(function() {
  var checked = $(this).is(':checked');
  if (checked) {
    var value = $( "#Product-select-associated-1 option:selected" ).val();
    //console.log(value);
    variantIdentifiers.push(value);
    //console.log(variantIdentifiers);
  } else {
    var value = $( "#Product-select-associated-1 option:selected" ).val();
    //console.log(value);
    position = $.inArray(value, variantIdentifiers);
    if ( ~position ) variantIdentifiers.splice(position, 1);
    //console.log(variantIdentifiers);
  }
});


$('#Product-select-associated-2').click(function() {
  var value = $( "#Product-select-associated-2 option:selected" ).val();
  $('#Product-check-associated-2').prop('checked', false);
  //console.log(value);
  position = $.inArray(value, variantIdentifiers);
  if ( ~position ) variantIdentifiers.splice(position, 1);
  //console.log(variantIdentifiers);
});

$("#Product-check-associated-2").click(function() {
  var checked = $(this).is(':checked');
  if (checked) {
    var value = $( "#Product-select-associated-2 option:selected" ).val();
    //console.log(value);
    variantIdentifiers.push(value);
    //console.log(variantIdentifiers);
  } else {
    var value = $( "#Product-select-associated-2 option:selected" ).val();
    //console.log(value);
    position = $.inArray(value, variantIdentifiers);
    if ( ~position ) variantIdentifiers.splice(position, 1);
    //console.log(variantIdentifiers);
  }
});

$('#Product-select-associated-3').click(function() {
  var value = $( "#Product-select-associated-3 option:selected" ).val();
  $('#Product-check-associated-3').prop('checked', false);
  //console.log(value);
  position = $.inArray(value, variantIdentifiers);
  if ( ~position ) variantIdentifiers.splice(position, 1);
  //console.log(variantIdentifiers);
});

$("#Product-check-associated-3").click(function() {
  var checked = $(this).is(':checked');
  if (checked) {
    var value = $( "#Product-select-associated-3 option:selected" ).val();
    //console.log(value);
    variantIdentifiers.push(value);
    //console.log(variantIdentifiers);
  } else {
    var value = $( "#Product-select-associated-3 option:selected" ).val();
    //console.log(value);
    position = $.inArray(value, variantIdentifiers);
    if ( ~position ) variantIdentifiers.splice(position, 1);
    //console.log(variantIdentifiers);
  }
});

$('#Product-select-associated-4').click(function() {
  var value = $( "#Product-select-associated-4 option:selected" ).val();
  $('#Product-check-associated-4').prop('checked', false);
  //console.log(value);
  position = $.inArray(value, variantIdentifiers);
  if ( ~position ) variantIdentifiers.splice(position, 1);
  //console.log(variantIdentifiers);
});

$("#Product-check-associated-4").click(function() {
  var checked = $(this).is(':checked');
  if (checked) {
    var value = $( "#Product-select-associated-4 option:selected" ).val();
    //console.log(value);
    variantIdentifiers.push(value);
    //console.log(variantIdentifiers);
  } else {
    var value = $( "#Product-select-associated-4 option:selected" ).val();
    //console.log(value);
    position = $.inArray(value, variantIdentifiers);
    if ( ~position ) variantIdentifiers.splice(position, 1);
    //console.log(variantIdentifiers);
  }
});


var value = $( ".product-single__variants[name='id'] option:selected" ).val();
//console.log("Current Variant ID: "+value);
variantIdentifiers.push(value);
//console.log(variantIdentifiers);

document.addEventListener('variant:change', function(evt) {
  var variant = evt.detail.variant.id; // Gives you access to the whole variant details
  variantIdentifiers[0] = JSON.stringify(variant);
  //console.log("Current Variant ID After Change: "+variant);
  //console.log(variantIdentifiers);
});


$( ".add-to-cart" ).on( "click", function(e) {
  $(this).attr("disabled", true);
  $(this).addClass('btn--loading');
  e.preventDefault();
  //console.log("Clicked");
  addAllItems(variantIdentifiers);
});
